module.exports = __webpack_public_path__ + "img/theme-dark.4aa1cd5e.png";